export const zipCodesServed = [
  "30011",
  "30014",
  "30015",
  "30016",
  "30018",
  "30025",
  "30052",
  "30054",
  "30055",
  "30056",
  "30070",
  "30501",
  "30502",
  "30503",
  "30504",
  "30506",
  "30507",
  "30511",
  "30516",
  "30520",
  "30521",
  "30527",
  "30529",
  "30530",
  "30542",
  "30543",
  "30547",
  "30548",
  "30549",
  "30553",
  "30554",
  "30558",
  "30564",
  "30565",
  "30566",
  "30567",
  "30601",
  "30603",
  "30604",
  "30605",
  "30606",
  "30607",
  "30608",
  "30619",
  "30620",
  "30621",
  "30622",
  "30624",
  "30625",
  "30628",
  "30630",
  "30633",
  "30634",
  "30635",
  "30641",
  "30642",
  "30643",
  "30645",
  "30646",
  "30648",
  "30650",
  "30655",
  "30656",
  "30662",
  "30663",
  "30666",
  "30668",
  "30673",
  "30677",
  "30680",
  "30683",
  "30828",
  "31064",
  "31085",
];
